/* Accordion Heading */

.accordionHeading {
  width: 100%;
  border: none;
  margin: 0;
  margin-bottom: var(--margin-bottom);
  margin-left: var(--margin-left);
  margin-right: var(--margin-right);
  margin-top: var(--margin-top);
  padding: 0;
  padding-bottom: var(--padding-bottom);
  padding-left: var(--padding-left);
  padding-right: var(--padding-right);
  padding-top: var(--padding-top);
  text-align: left;
  box-sizing: border-box;
  display: block;
  cursor: pointer;
  background: transparent;
  scroll-margin-top: var(--scroll-margin-top);
}

.accordionHeading:disabled {
  cursor: auto;
  color: var(--colors-transparent-black-twenty);
}

/* Accordion Content */

.accordionContentWrapper {
  display: grid;
  grid-template-rows: 0fr;
  transition-property: grid-template-rows;
  transition-timing-function: ease;
  transition-duration: var(--transition-duration);
}

.accordionContentWrapper__expanded {
  grid-template-rows: 1fr;
}

.accordionContent {
  overflow: hidden;
}

.accordionContent_inner {
  margin-bottom: var(--margin-bottom);
  margin-left: var(--margin-left);
  margin-right: var(--margin-right);
  margin-top: var(--margin-top);
  padding-bottom: var(--padding-bottom);
  padding-left: var(--padding-left);
  padding-right: var(--padding-right);
  padding-top: var(--padding-top);
}

@keyframes accordionContentFadeIn {
  0% {
    opacity: 0;
    transform: scale3d(0.99, 0.99, 1);
  }

  50% {
    opacity: 0.5;
  }

  100% {
    opacity: 1;
    transform: scale3d(1, 1, 1);
  }
}

.accordionContent__animated {
  animation-name: accordionContentFadeIn;
  animation-timing-function: cubic-bezier(0.25, 0.46, 0.45, 0.94);
  animation-duration: var(--transition-duration);
}

.accordionContent__overflowVisible {
  overflow: visible;
}

/* Accordion Summary */

.accordionSummaryWrapper {
  display: grid;
  grid-template-rows: 0fr;
}

.accordionSummaryWrapper__visible {
  grid-template-rows: 1fr;
}

.accordionSummary {
  overflow: hidden;
}

.accordionSummary_inner {
  margin-bottom: var(--margin-bottom);
  margin-left: var(--margin-left);
  margin-right: var(--margin-right);
  margin-top: var(--margin-top);
  padding-bottom: var(--padding-bottom);
  padding-left: var(--padding-left);
  padding-right: var(--padding-right);
  padding-top: var(--padding-top);
}

/* Accordion Indicator */

.accordionIndicator {
  transition: transform 250ms ease;
  transform: rotate(0deg);
  color: currentcolor;
}

.accordionIndicator__expanded {
  transform: rotate(180deg);
}
